import { Box } from "@jewlr/storybook/core"
import { FloatInput } from "@jewlr/storybook/form"
import PropTypes from "prop-types"
import React from "react"
import { Controller } from "react-hook-form"

import { InputWrapper, SectionTitle, Text } from "areas/order/components"

const ContactInformation = ({ control }) => (
  <Box flex="1" mb={2}>
    <SectionTitle>Contact Information</SectionTitle>
    <Text mb={2}>Please enter your contact information below:</Text>
    <InputWrapper>
      <Controller
        control={control}
        name="contact_name"
        render={({ field, fieldState: { error } }) => (
          <FloatInput
            error={error}
            label="Full name"
            placeholder="Full name"
            variant="checkout"
            {...field}
          />
        )}
      />
    </InputWrapper>
    <InputWrapper>
      <Controller
        control={control}
        name="contact_email"
        render={({ field, fieldState: { error } }) => (
          <FloatInput
            error={error}
            label="Email Address"
            placeholder="Email Address"
            type="email"
            variant="checkout"
            {...field}
          />
        )}
      />
    </InputWrapper>
    <InputWrapper>
      <Controller
        control={control}
        name="contact_phone_num"
        render={({ field, fieldState: { error } }) => (
          <FloatInput
            error={error}
            label="Phone number"
            placeholder="Phone number"
            variant="checkout"
            {...field}
          />
        )}
      />
    </InputWrapper>
  </Box>
)

ContactInformation.propTypes = {
  control: PropTypes.object,
}

export default ContactInformation
